
const digest = 'd580b76b8ac07f86fd3a1c29aecac683fc62015ea0ba56a7cd501a16fba817ad';
const classes = {"wrapper":"_wrapper_1ku6x_1"};
const css = `._wrapper_1ku6x_1 {
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  